<template>
  <div class="videos" :style="wrap_style">
    <div class="main">
      <div class="row">
        <div v-for="(item,index) in videos.slice(0,3)" class="video" @click="click_video(item)">
          <img class="cover" :src="item.img">
          <div class="name">{{item.name}}</div>
        </div>
      </div>
      <div class="row" v-if="videos.length > 3">
        <div v-for="(item,index) in videos.slice(3,6)" class="video" @click="click_video(item)">
          <img class="cover" :src="item.img">
          <div class="name">{{item.name}}</div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>

  import click_handler from '../../tools/mgtv/click'
  import {openLink} from '../../tools/mgtv/link'
  import download from '../../tools/mgtv/downapp'
  import {getJSON} from '../../api/myaxios'

  export default {
    name: 'ActVideosRecommend',
    props: {
      info: {
        type: Object,
        default: function () {
          return {
            name: '热门视频',
            color:"red",
            disable_click: false,
          }
        }
      }
    },
    data() {
      return {
        gact: window.gact,
        videos: []
      }
    },
    computed: {
      wrap_style() {
        return {
          color:`${this.info.color} !important`
        }
      },
      disable_click() {
        return !!this.info.disable_click;
      }
    }
    ,
    methods: {
      get_videos() {
        getJSON('//vipact3.api.mgtv.com/api/v1/act/banner').then(res => {
          if (res && res.ret === 0) {
            this.videos = res.data.list.videos;
          }
        })
      },
      click_video(item) {
        if (this.disable_click) {
          return;
        }
        click_handler(item.name + '-点击视频', function () {
          setTimeout(() => {
            openLink(item.url);
          }, 500);
        }, {
           need_act: false,
        })
      }
    }
    ,
    created() {
      console.log('created',this.info)
      this.get_videos();
    },
    mounted() {

    }

  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="stylus">
  @import "../../share/mixins.styl"

  .videos
    position relative
    width 7.5rem
    .title
      width 100%
      text-align center
      font-size .3rem
      height .6rem
      line-height @height
      font-weight bold
      .more
        position absolute
        right .2rem
        display inline-block
        height .6rem
        font-size .26rem
        line-height @height
    .main
      width 100%
      position relative
      padding 0 .3rem
      .row
        display flex
        justify-content space-between
        margin-top .2rem
        .video
          width 2.18rem
          text-align center
          display inline-block
          position relative
          .cover
            display block
            margin 0 auto
            width 2.02rem
          .name
            display block
            font-size .26rem
            margin-top .04rem
            text-align center
            ellipsis()

</style>



// WEBPACK FOOTER //
// src/components/ConfigUI/ActVideosRecommend.vue